import { PAGE_HEADER_HEIGHT } from "@constants";
import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LeftSideBar = () => {
  const navigate = useNavigate();
  const appBarHeight = document.getElementById("app-bar")?.clientHeight;
  return (
    <Stack
      width={56}
      minWidth={56}
      height={1}
      bgcolor="customBackground.main"
      borderRight={1}
      borderColor="divider"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: PAGE_HEADER_HEIGHT,
          maxHeight: PAGE_HEADER_HEIGHT,
          minHeight: PAGE_HEADER_HEIGHT,
          top: appBarHeight,
          position: "sticky",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <IconButton onClick={() => navigate("/commandcenter")}>
          <ArrowBack />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default LeftSideBar;
